import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";
import { generateBill, getBills, saveBillPayment } from "services/BookingService";
import { getAgents } from "services/AgentService";


const BillingForm = () => {
  const [formData, setFormData] = useState({
    agent_id: "",
    from_date: "",
    to_date: ""   
  });
  
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [agents, setAgents] = useState([]);
    const [bills, setBills] = useState([]);
    const [successMsg, setSuccessMsg] = useState(null); 
    const [errorMsg, setErroMsg] = useState(null);
    const [paymentForms, setPaymentForms] = useState({});
    const [paymentLoading, setPaymentLoading] = useState({});

    useEffect(() => {
      getAgentsList(); 
      getBillsList();      
    }, []);
    
   
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({ ...prevData, [name]: value }));      
    };
  
     const getAgentsList = () => {
        getAgents().then((response) => {
          if (response && response.data.success) {
            setAgents(response.data.agents);           
          }
        });
      };
    
    const getBillsList = () => {
      getBills().then((response) => {
        if (response && response.data.success) {
          setBills(response.data.billings);           
        }
      });
    };
    
    
  
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          const newErrors = validate();
          if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
          } else {
            setErrors({});
            setSuccessMsg(null);
            setErroMsg(null);
            setLoading(true);           
            let response= await generateBill(formData);    
            setLoading(false);
            if (response?.data?.success) {
              setSuccessMsg(response?.data?.message);
              getBillsList();  
            } else {              
              setErroMsg(response?.data?.message);
            }
          }
        } catch (error) {
          console.error("Error adding billing:", error);
        }
      };
  
  const validate = () => {
        const newErrors = {};
        return newErrors;
      };
  
  const handlePaymentChange = (billId, field, value) => {
        setPaymentForms({
          ...paymentForms,
          [billId]: {
            ...paymentForms[billId],
            [field]: value
          }
        });
      };
    
  const handleAddPayment = async (e, billId) => {
        e.preventDefault();
        const paymentData = paymentForms[billId];
        console.log('Adding payment for Bill ID:', billId, paymentData);
        let payload = {};
        payload = paymentData;
        payload.billing_id	= billId;
        setPaymentLoading({ ...paymentLoading, [billId]: true });
        try {
              let response= await saveBillPayment(payload); 
              setPaymentLoading({ ...paymentLoading, [billId]: false }); 
              if (response?.data?.success) {
                getBillsList(); 
              } else {              
              // setErroMsg(response?.data?.message);
              }
              setPaymentForms({
                ...paymentForms,
                [billId]: { date: '', amount: '', remark: '' }
              });
          
              } catch (error) {
                console.error('Failed to add payment:', error);
              } finally {
                setPaymentLoading({ ...paymentLoading, [billId]: false });
              }
      };

  const totalAdvance = (index) =>{
    const totalAdvanceAmount = bills[index].payments.reduce((sum, payment) => sum + Number(payment.amount), 0);
    return totalAdvanceAmount;

  }   
  const totalBalnce = (index) =>{
    const totalCost = bills[index].total_cost ;
    const totalAdvanceAmount = (Number(bills[index].total_advance)) + (bills[index].payments.reduce((sum, payment) => sum + Number(payment.amount), 0));
    const totalBalnce = totalCost - totalAdvanceAmount;
    return totalBalnce;

  }    

  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-users"></i>
        </div>
        <div className="header-title">
          <h1>Generate Billing</h1>
          <small>New Billing</small>
        </div>
      </section>
      <div className="content">
        <div className="row">
          <div className="col-sm-12">
            <div
              className="card lobicard all_btn_card"
              id="lobicard-custom-control1"
              data-sortable="true"
            >
              <div className="card-header all_card_btn">
                <div className="card-title custom_title">
                  <Link className="btn btn-add" to="/billings">
                    <i className="fa fa-file-text-o"></i> All Billing{" "}
                  </Link>
                </div>
              </div>
              <div className="card-body">
              <p style={{color:'green'}}>{successMsg}</p>
              <p style={{color:'red'}}>{errorMsg}</p>
                <form className="col-sm-12" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-3 col-md-6 mb-3">
                      <div className="form-group">
                        <label>Select Comapny Name</label>
                        <div className="search-form-input-1" id="first-select">
                        <select
                          name="agent_id"
                          value={formData.agent_id}
                          onChange={handleChange}
                          className="form-control"
                          required
                        >
                          <option value="">Comapny</option>
                          
                        { agents.map((agent) => (
                          <option value={agent.id}>{agent.company_name}</option>
                        ))}
                         
                        </select>
                        </div>
                      </div>
                    </div>
                   
                    <div className="col-lg-2 col-md-6 mb-3">
                      <div className="form-group">
                        <label>From Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="from_date"
                          placeholder="From Date"
                          value={formData.from_date}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-6 mb-3">
                      <div className="form-group">
                        <label>To Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="to_date"
                          placeholder="To Date"
                          value={formData.to_date}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-6">
                      <div className="reset-button">
                      <button type="submit" className="btn btn-success generate-bill" disabled={loading}>
                        {loading ? "Generating..." : "Generate Bill"}
                      </button>
                       
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="content pt-0">
        <div className="row">
          <div className="col-lg-12 pinpin">
            <div className="card lobicard mt-2" data-sortable="true">
              <div className="card-header">
                <div className="card-title custom_title">
                  <h4>Billing List</h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    id="dataTableExample1"
                    className="table table-bordered table-striped table-hover"
                  >
                    <thead className="back_table_color">
                      <tr className="info">
                        <th>Sno. </th>
                        <th>Invoice No </th>
                        <th>Agent Name </th>
                        <th>From Date </th>
                        <th>To Date </th>
                        <th>Total Cost </th>
                        <th>Total Advance</th>
                        <th>Balance</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>

                    {bills.length > 0 ? (
                        bills.map((bill, pindex) => (
                        <>
                        <tr>
                        <td>{bill.id} </td>
                        <td>{bill.invoice_no} </td>
                        <td>{bill?.agent?.agent_name}</td>
                        <td>{bill.from_date}</td>
                        <td>{bill.to_date}</td>
                        <td>{bill.total_cost}</td>
                        <td>{Number(bill.total_advance )+ Number(bill.payments.reduce((sum, payment) => sum + Number(payment.amount || 0), 0))}</td>
                        <td>{bill.total_cost - (Number(bill.total_advance )+ Number(bill.payments.reduce((sum, payment) => sum + Number(payment.amount || 0), 0)))}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm "
                            data-toggle="collapse"
                            data-target={ "#details"+bill.id}
                            aria-expanded="false"
                            aria-controls={ "#details"+bill.id}
                          >
                            View All{" "}
                          </button>
                          <button
                            type="button"
                            className="btn btn-add btn-sm"
                            data-toggle="modal"
                            data-target="#customer1"
                          >
                            <i className="fa fa-download"></i>
                          </button>
                        </td>
                      </tr>
                      <tr id={ "details"+bill.id} className="collapse">
                        <td colspan="10">
                          <div className="card-body p-0">
                          <form className="col-sm-12" onSubmit={(e) => handleAddPayment(e, bill.id)}>
                          <div className="row">
                            <div className="col-lg-3 col-md-6 mb-3">
                              <div className="form-group">
                                <label>Date</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  value={paymentForms[bill.id]?.date || ''}
                                  onChange={(e) => handlePaymentChange(bill.id, 'date', e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6 mb-3">
                              <div className="form-group">
                                <label>Amount</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={paymentForms[bill.id]?.amount || ''}
                                  onChange={(e) => handlePaymentChange(bill.id, 'amount', e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6 mb-3">
                              <div className="form-group">
                                <label>Remark</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={paymentForms[bill.id]?.remark || ''}
                                  onChange={(e) => handlePaymentChange(bill.id, 'remark', e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6 mb-3">
                              <div className="reset-button">
                                <button type="submit" className="btn btn-success generate-bill" disabled={paymentLoading[bill.id]}>
                                   {paymentLoading[bill.id] ? (
                                      <>
                                        <i className="fa fa-spinner fa-spin"></i> Adding...
                                      </>
                                    ) : (
                                      'Add Payment'
                                    )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                          </div>

                          <table className="table table-bordered table-striped table-hover">
                              <thead>
                                <tr className="info">
                                  <th>Sno.</th>
                                  <th>Check In</th>
                                  <th>Check Out</th>
                                  
                                  <th>Guest Name</th>
                                  <th>Phone No</th>
                                  <th>Amount</th>
                                  <th>Advance</th>
                                </tr>
                              </thead>
                              <tbody>
                                {bill.bookings.map((booking, index) => (
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{booking.checkIn}</td>
                                    <td>{booking.checkOut}</td>                                            
                                    <td>
                                      {booking.guestName}
                                    </td>
                                    <td>
                                      {booking.guestPhone}
                                    </td>
                                    <td>{booking.totalCost}</td>
                                    <td>{booking.totalAdvance}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          <div className="totle-price">
                            <div className="price-box">
                              <table className="table">
                                <tr>
                                  <td>Total Cost</td>
                                  <td>{bill.total_cost}</td>
                                </tr>
                                <tr>
                                  <td>Total Advance</td>
                                  <td>{ bill.total_advance} {/*totalAdvance(pindex)*/}</td>
                                </tr>
                                {bill.payments.map((payment, index) => (
                                  <tr>
                                  <td>{payment.date}|{payment.remark}</td>
                                  <td>{payment.amount}</td>
                                </tr>
                                ))}  
                                <tr>
                                  <td>Balance</td>
                                  <td>{totalBalnce(pindex)}</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center">
                            No bookings found.
                          </td>
                        </tr>
                      )}

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BillingForm;
